"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _index = require("../reducers/index");

var _index2 = _interopRequireDefault(_index);

var _api = require("../middleware/api");

var _api2 = _interopRequireDefault(_api);

var _event = require("../middleware/event");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function configureStore() {
  var middleWares = [_reduxThunk2.default, _api2.default, _event.eventEmitter];

  if (process.env.NODE_ENV !== "production") {
    middleWares.push(_reduxLogger2.default);
  }

  var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, middleWares)(_redux.createStore);

  return createStoreWithMiddleware(_index2.default);
}